import { useFetch } from "../../hooks/useFetch";
import LoadSimple from "../LoadSimple";
import Modal from "react-modal";
import ModalDeleteCis from "./ModalDeleteCis";
import { useState, useEffect } from "react";
import ModalCisAfecta from "./ModalCisAfecta";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
import ModalLinKHost from "./ModalLinKHost";
import { permisos_codigo_id } from "../generales/GroupsId";
const deleteCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "30%",
    padding: "20px",
  },
};
/* estilos modal crear relacion */
const CisAfectaModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "90%",
    padding: "20px",
  },
};
const hostListModalSyncStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "90%",
    padding: "20px",
  },
};
const CisList = ({
  pageActual,
  limitList,
  dataList,
  startLimit,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  cisSelected,rowSelected,
  setCisSelected,
  mode,view,
   poolRows,setPoolRows,
  handleShowPopup,buscar_cis,
  languaje,userPermissions
}) => {
  // const dataUsers=useFetch('cassia/ci','',localStorage.getItem('access_token'),'GET',server)

  const [deleteCisModalOpen, setdeleteCisModalOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({});
  const [CisAfectaModalOpen, setCisAfectaModalOpen] = useState(false);
  const [cisSelectedAux, setCisSelectedAux] = useState([]);
  const [hostsListSyncModalOpen, setHostsListSyncModalOpen] =useState(false);
  const [poolRows2,setPoolRows2]=useState([]);
  const status_translate={
    'FINALIZED':'Finalizado',
    'CHANGE_PENDING':'Cambio Pendiente',
    'IN_PROGRESS':'En Progreso',
    'ON_HOLD':'En Espera',
    'CANCELLED':'Cancelado',
    'OPEN':'Abierto'
  }
  const status_color={
    'FINALIZED':'transparent',
    'CHANGE_PENDING':'var(--yellow-low)',
    'IN_PROGRESS':'En Progreso',
    'ON_HOLD':'En Espera',
    'CANCELLED':'Cancelado',
    'OPEN':'Abierto'
  }
  // var dataList=(searchTerm==='')?dataUsers.data:searchResults;
  // console.log(dataList);
  // console.log("intervalo de resultados", pageActual, limitList);
  function openDeleteUserModal() {
    setdeleteCisModalOpen(true);
  }
 function openHostsListSyncModal(elemento) {
   setCisSelectedAux(elemento);
    setHostsListSyncModalOpen(true);
  }

  function closHostsListSyncModal() {
    
    setHostsListSyncModalOpen(false);
  }
  function closDeleteCisModal() {
    setdeleteCisModalOpen(false);
  }
  const handledeleteUserClick = (data) => {
    openDeleteUserModal();
    setUserSelected(data);
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  
  const cisSelectRow = (elemento) => {
    view()
    setCisSelected(elemento);
  };
  function closeCisAfectaModal() {
    setCisAfectaModalOpen(false);
  }

  const openCisAfectaModal = (elemento) => {
    setCisSelectedAux(elemento);
    setCisAfectaModalOpen(true);
  };
   const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0 });

  const handleMouseMove = (e) => {
    setTooltip({
      visible: true,
      x: e.clientX + 10, // un poco a la derecha del cursor
      y: e.clientY + 10, // un poco abajo del cursor
    });
  };

  const handleMouseLeave = () => {
    setTooltip((t) => ({ ...t, visible: false }));
  };
  return (
    <>
      <div className="cont-row-user-list">
        {dataUsers.loading ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio"+mode+" tooltip-container"}
                key={indice}
                onClick={() => 
                  cisSelectRow(elemento)
                  // view(elemento)
                }
                 onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
              >
                <div className="field-body-table-mantenimiento field-small">
                 <div className='cont-checkbox'>
                 <input type='checkbox' checked={poolRows.some((row) => row === elemento.id)} className='NotifiCheckBox ' style={{height:'15px'}}   onClick={(e) => {
          e.stopPropagation(); // ✅ evita que el click suba al padre
          rowSelected(elemento);
        }} ></input>
                </div>
                </div>
                <div className="field-body-table-cis field-medium">
                  {elemento.folio}
                </div>
                <div className="field-body-table-cis field-medium">
                  {elemento.ip}
                </div>
                {/* <div className='field-body-table-cis field-larger'>
                {elemento.name.slice(0,35)}...
              </div> */}
                <div className="field-body-table-cis field-larger" style={{width:'20%'}}>
                  {elemento.name}
                </div>
                <div className="field-body-table-cis field-larger">
                  {elemento.service}
                </div>
                {/* <div className="field-body-table-cis field-small">
                  {elemento.active_event}
                </div>
                <div className="field-body-table-cis field-small  ">
                  {elemento.ticket_active}
                </div> */}
                <div className="field-body-table-cis field-larger">
                  {elemento.location}
                </div>
                <div className="field-body-table-cis field-larger">
                  {elemento.affiliation}
                </div>
                <div className="field-body-table-cis field-larger">
                  {elemento.subgroup_name}
                </div>
                <div className="field-body-table-cis field-medium  ">
                  <div className="tagIpAvailable" style={{background: status_color[elemento.status],border:'1px solid '+status_color[elemento.status]}}>
                  {status_translate[elemento.status]}
                  </div>
                  
                </div>
                <div className="field-body-table-cis field-small  ">
                  <div className='pointProblemCell' style={{background:(elemento.active_event==1)?'rgba(255, 34, 34, 0.22)':'',borderColor:(elemento.active_event==1)?'#a00':''}}>
                    {
                      ((elemento.active_event==0) )?'':<div className='centerPoint' style={{background:(elemento.active_event==1)?'red':'',width:'12px',height:'12px'}}></div>
                    }
                    </div>
                </div>
                <div className="field-body-table-cis field-larger">
                  {/* <div style={{width:'33%'}}>
                    <img
                      className="img-field-acciones"
                      src="/iconos/cis-afecta.png"
                      title="Afecta"
                      name="Afecta"
                      alt="Afecta"
                      style={{ height: "85%" ,width:'40%'}}
                      ci_id={elemento.ci_id}
                      onClick={(e) => {
                        e.stopPropagation();
                        openHostsListSyncModal(elemento);
                      }}
                     
                    />
                  </div> */}
                  {userPermissions.some(
            (objeto) => objeto.permission_id === permisos_codigo_id["editar cis"]
          ) ?  
         <div style={{width:'33%'}}>
                    <img
                      className="img-field-acciones"
                      src="/iconos/editar.png"
                      title="Editar"
                      name="Editar"
                      ci_id={elemento.ci_id}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleChangEdit(elemento);
                      }}
                      style={{width:'40%'}}
                    />
                  </div>
         :''}
                  {userPermissions.some(
            (objeto) => objeto.permission_id === permisos_codigo_id["eliminar cis"]
          ) ?  
        <div  style={{width:'33%'}}>
                    <img
                      className="img-field-acciones"
                      src="/iconos/delete.png"
                      title="Eliminar"
                      name="Eliminar"
                      ci_id={elemento.ci_id}
                      onClick={(e) => {
                        e.stopPropagation();
                        handledeleteUserClick(elemento);
                      }}
                      style={{width:'40%'}}
                    />
                  </div>
         :''}
                  
                </div>
                {<div className="tooltip-content" onClick={(e)=>e.stopPropagation()} style={{left:'50%',width:'auto',minWidth:'20%',maxWidth:'50%',boxShadow:'0px 0px 10px rgba(0, 0, 0, 0.34)',padding:'10px',borderRadius:'5px',zIndex:1000, overflowY:'auto',maxHeight:'280px',position: "fixed",
            top: tooltip.y,
            left: tooltip.x}}>
                                            {<>
                                            <div style={{display:'flex',flexDirection:'row',alignItems:'start',gap:'5px'}}>
                                                 <div style={{justifyContent:'center',fontWeight:'bold',width:'100%',display:'flex'}}>{elemento.name} </div>
                                                  
                                                </div>
                                                <hr></hr>
                                                <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:'5px'}}>
                                                 <div style={{fontWeight:'bold'}}>Descripción:</div>
                                                  <div>{elemento.description} </div>
                                                </div>
                                                 <hr></hr>
                                                <div style={{display:'flex',flexDirection:'row',alignItems:'center',gap:'5px'}}>
                                                  <div style={{fontWeight:'bold'}}>Marca:</div>
                                                  <div>{elemento.brand} </div></div>
                                                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',gap:'5px'}}>
                                                  <div style={{fontWeight:'bold'}}>Modelo:</div><br></br>
                                                  <div>{elemento.model} </div></div>
                                                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',gap:'5px'}}>
                                                  <div style={{fontWeight:'bold'}}>Versión:</div><br></br>
                                                  <div>{elemento.version} </div></div>
                                                  <br></br>
                                                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',gap:'5px'}}>
                                                  <div style={{fontWeight:'bold'}}>MAC address:</div><br></br>
                                                  <div>{elemento.mac} </div></div>
                                                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',gap:'5px'}}>
                                                  <div style={{fontWeight:'bold'}}>No. Serie:</div><br></br>
                                                  <div>{elemento.serial_no} </div></div>
                                                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',gap:'5px'}}>
                                                  <div style={{fontWeight:'bold'}}>Status</div><br></br>
                                                  <div>{elemento.status_conf} </div></div>
                                                  </>
                                             }
                                            
            </div>}
              </div>
            ))
        )}
        {dataUsers.loading == false && dataList.length == 0 ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}</div>
        ) : (
          ""
        )}
      </div>
      <Modal
        isOpen={deleteCisModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteCisModal}
        style={deleteCisModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
      >
        <ModalDeleteCis
          server={server}
          setRegisterIsValid={setRegisterIsValid}
          setData={setData}
          setLoading={setLoading}
          setError={setError}
          cis={userSelected}
          languaje={languaje}
          closDeleteCisModal={closDeleteCisModal}
          handleShowPopup={handleShowPopup}
        ></ModalDeleteCis>
      </Modal>
      {/* modal cis que afecta */}
      <Modal
        isOpen={CisAfectaModalOpen}
        // isOpen={false}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closeCisAfectaModal}
        style={CisAfectaModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
      >
        <ModalCisAfecta
          server={server}
          cisSelected={cisSelectedAux}
          closeCisAfectaModal={closeCisAfectaModal}
          languaje={languaje}
          mode={mode}
        ></ModalCisAfecta>
      </Modal>
      <Modal
        isOpen={hostsListSyncModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closHostsListSyncModal}
        style={hostListModalSyncStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalLinKHost poolRows={poolRows2} setCisSelectedAux={setCisSelectedAux} server={server} handleShowPopup={handleShowPopup}  cisSelectRow={cisSelectedAux} setPoolRows={setPoolRows2} languaje={languaje}  mode={mode} closeAddHostModal={closHostsListSyncModal}  ></ModalLinKHost>
    </Modal>
    </>
  );
};

export default CisList;
